import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { APISettings } from '@/Api/apiConfig';
import { APIUrl } from '@/Api/apiUrls';
import { LoginParams } from '@/Types/auth.interface';

export const verifyLogin = createAsyncThunk(
  'auth/login',
  async ({ email, password }: LoginParams, { rejectWithValue }) => {
    try {
      const config = {
        headers: APISettings.headers
      };
      const { data } = await axios.post(
        APIUrl.AUTH_LOGIN_URL,
        { email: email, password: password },
        config
      );
      return data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
